// extracted by mini-css-extract-plugin
module.exports = {"text":"EABD2HomeCardBack_text__3-UdJ","emphasized":"EABD2HomeCardBack_emphasized__32HPK","smallText":"EABD2HomeCardBack_smallText__K1rVe"};